export const splashPageWatcher = {
  initial: 'idle',
  states: {
    idle: {
      on: {
        LAYOUT_CHANGE_END: {
          actions: ['removeSplashPage'],
        },
      },
    },
  },
};
